/**
 * Permissive phone-number check for the marketplace booking form.
 *
 * Intentionally loose: it only rejects *obviously* invalid input (letters,
 * far-too-short/long), not country-specific formats. After stripping common
 * separators, a valid value is an optional single leading `+` followed by
 * 7–15 digits (loosely E.164). Used to gate the guest Book/Pay buttons and
 * to surface an inline error — never sent to the backend in a special form.
 */
export function validatePhone(raw: string): boolean {
  const cleaned = raw.replace(/[\s\-().]/g, '');
  return /^\+?\d{7,15}$/.test(cleaned);
}
